import { module as modujs } from "modujs";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Lenis from "lenis";

gsap.registerPlugin(ScrollTrigger);

export default class extends modujs {
	constructor(m) {
		super(m);

		this.events = {
			click: {
				anchor: "buttonClick",
			},
		};
	}

	init() {
		this.lenis = new Lenis({
			lerp: 0.2,
			duration: 0.6,
		});

		window.lenis = this.lenis;

		this.lenis.on("scroll", (e) => {
			if (e.direction == 1) {
				document.querySelector("html").classList.remove("is-scroll-up");
				document.querySelector("html").classList.add("is-scroll-down");
			} else {
				document.querySelector("html").classList.remove("is-scroll-down");
				document.querySelector("html").classList.add("is-scroll-up");
			}
		});

		this.lenis.on("scroll", ScrollTrigger.update);

		this._rafCallback = (time) => this.lenis.raf(time * 1000);
		gsap.ticker.add(this._rafCallback);

		gsap.ticker.lagSmoothing(0);

		//stop scrolling
		document.addEventListener("lenisToggle", (event) => {
			if (event.detail.status === "stopped") {
				this.lenis.stop();
			} else if (event.detail.status === "started") {
				this.lenis.start();
			}
		});

		document.lenis = this.lenis;
	}

	anchorClick(e) {
		e.preventDefault();
		this.scrollTo(document.querySelector(e.target.hash));
	}

	buttonClick(e) {
		e.preventDefault();

		// Change from e.target.getAttribute('href') to e.target.getAttribute('data-href')
		const targetSelector = e.target.getAttribute("data-href"); // Get the value from the new data-href attribute

		const targetElement = document.querySelector(targetSelector);

		if (targetElement) {
			this.scrollTo(targetElement);
		} else {
			console.error(`Scroll target not found for selector: ${targetSelector}`);
		}
	}

	scrollTo(target) {
		this.lenis.scrollTo(target, {
			offset: -document.querySelector(".c-header").getBoundingClientRect().height,
		});
	}

	destroy() {
		this.lenis.destroy();
		gsap.ticker.remove(this._rafCallback);
	}
}
